export const setNextStepAvailable = available => {
    return async dispatch => {
        dispatch({type: 'NEXT_STEP_AVAILABLE', available})
    }
}